'use client';

import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';

const navLinks = [
  { label: 'Home', href: '/' },
  { label: 'Product', href: '/product' },
  { label: 'Industries', href: '/industries' },
  { label: 'ROI Calculator', href: '/roi-calculator' },
  { label: 'Why BridgeFlow', href: '/why-bridgeflow' },
];

export default function MarketingHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const pathname = usePathname();

  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handler);
    return () => window.removeEventListener('scroll', handler);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-[#0A0F1A]/95 backdrop-blur-md border-b border-[#1E293B]' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 lg:h-20">
          {/* Logo */}
          <a href="https://www.irongatesupply.com" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 group">
            <img
              src="/assets/images/7a15e6d7-4494-4b56-acb6-b8320904c93b-1778298607010.png"
              alt="BridgeFlow™ MTE System"
              className="h-10 w-auto object-contain"
            />
            <img
              src="/assets/images/ISlogo_no_background-1778299302885.jpeg"
              alt="Iron Gate Supply"
              className="h-10 w-auto object-contain"
            />
          </a>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-1">
            {navLinks?.map((link) => (
              <Link
                key={link?.href}
                href={link?.href}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-150 ${
                  pathname === link?.href
                    ? 'text-[#F97316] bg-[#F97316]/10'
                    : 'text-[#94A3B8] hover:text-[#F1F5F9] hover:bg-[#1E293B]/60'
                }`}
              >
                {link?.label}
              </Link>
            ))}
          </nav>

          {/* CTA */}
          <div className="hidden lg:flex items-center gap-3">
            <Link
              href="/contact"
              className="px-4 py-2 text-sm font-medium text-[#94A3B8] hover:text-[#F1F5F9] transition-colors"
            >
              Contact
            </Link>
          </div>

          {/* Mobile toggle */}
          <button
            className="lg:hidden p-2 rounded-lg text-[#94A3B8] hover:text-[#F1F5F9] hover:bg-[#1E293B]"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle menu"
          >
            {mobileOpen ? (
              <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd"/>
              </svg>
            ) : (
              <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clipRule="evenodd"/>
              </svg>
            )}
          </button>
        </div>

        {/* Mobile menu */}
        {mobileOpen && (
          <div className="lg:hidden border-t border-[#1E293B] py-4 space-y-1">
            {navLinks?.map((link) => (
              <Link
                key={link?.href}
                href={link?.href}
                onClick={() => setMobileOpen(false)}
                className={`block px-4 py-2.5 rounded-lg text-sm font-medium transition-all ${
                  pathname === link?.href
                    ? 'text-[#F97316] bg-[#F97316]/10'
                    : 'text-[#94A3B8] hover:text-[#F1F5F9] hover:bg-[#1E293B]'
                }`}
              >
                {link?.label}
              </Link>
            ))}
            <div className="pt-3 border-t border-[#1E293B] flex flex-col gap-2">
              <Link href="/contact" onClick={() => setMobileOpen(false)} className="block px-4 py-2.5 text-sm font-medium text-[#94A3B8] hover:text-[#F1F5F9]">Contact</Link>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
